/* 
  일자    : 2020.03.06
  작성자  : 오순영
  내용    : Context Menu 함수 작성
*/
const state = {
  /* params: {
    pageId: "", // 화면 아이디 (나의공간&협업공간, 공유받은 컨텐츠 구분)
    itemIds: [], // 파일 아이디
    itemType: "", // 파일 확장자
    fileName: null,
    multiSelect: false, // 복수 선택 여부
    external: false, // 외부망 접속 여부
    groupId: null, // 공간 아이디
    folderId: null // 폴더 아이디
  } */
  params: {}
};

const getters = {};

const actions = {
  /* context menu 파라미터 설정 */
  setContextMenuParams({ state, commit }, payload) {
    commit("resetStateParams");
    console.log("#################################");
    console.log(payload);
    console.log("#################################");
    let id = null; /* 파일or페이퍼or폴더 아이디 */
    let type = payload.itemList[0].type; /* 타입(파일/페이퍼/폴더) */
    let fileArr = []; /* 파일 목록 */
    let belongId = payload.belongId; /* 소속된 폴더or카테고리 아이디 */
    let checkedIds = payload.checkList; // 체크 된 아이디 목록
    let checkedItems = payload.itemList;
    let multiSelect = false; // 복수 선택 여부

    if (type === "folder") {
      checkedItems.forEach(function(item, index, arr) {});
    } else if (type === "file") {
    } else if (type === "paper") {
      checkedItems.forEach(function(item, index, arr) {});
    }
    const params = {
      groupId: payload.groupId,
      itemType: checkedItems[0].type,
      fileId: checkedItems[0].fileId,
      fileName: checkedItems[0].fileName,
      folderId: checkedItems[0].folderId,
      folderName: checkedItems[0].folderName,
      parentFolderId: checkedItems[0].parentFolderId,
      grade: checkedItems[0].docGrade
    };
    /* const params = {
      itemType: checkedItems[0].type,
      itemName: checkedItems[0].itemName,
      itemId: checkedItems[0].itemId,
      itemIds: checkedIds,
      grade: checkedItems[0].docGrade,
      groupId: payload.groupId,
      belongId: payload.belongId
    }; */
    commit("setStateParams", params);
    /* for (let i = 0; i < items.length; i++) {
      let item = items[i];
      let itemName = item.itemName;
      if (itemName !== null) {
        type = itemName.substring(
          itemName.lastIndexOf(".") + 1,
          itemName.length
        ); // 파일 확장자
      }
      id = item.itemId; // 파일 아이디

      if (fileArr.length > 0) {
        if (!fileArr.includes(id)) {
          fileArr.push(id);
        }
      } else {
        fileArr.push(id);
      } */

    // 확장자 구별
    /*  if (type === "docx" || type === "pptx" || type === "xlsx") {
        type = "office";
      } else if (type === "paper") {
        type = type;
      } else {
        if (item.isFolder) {
          type = "folder";
        } else {
          type = "file";
        }
      } */

    /* if (state.params.itemType !== "") {
        if (type !== state.params.itemType) {
          type += ", " + state.params.itemType;
        }
        multiSelect = true;
      } */

    /*  const params = {
        itemType: type,
        itemIds: fileArr,
        multiSelect: multiSelect,
        groupId: payload.groupId,
        folderId: payload.folderId,
        fileName: itemName
      }; */
    //commit("setStateParams", params);
    //}
  },

  /* context menu 호출 */
  showContextMenu(context, payload) {
    const menu = payload.menu;
    if (!menu) {
      return;
    }
    menu.style.left = payload.event.pageX - 2 + "px";
    menu.style.top = payload.event.pageY - 2 + "px";

    menu.classList.add("active");
  }
};

const mutations = {
  /* context menu 파라미터 설정 */
  setStateParams(state, params) {
    /* state.params.groupId = params.groupId;
    state.params.folderId = params.folderId;
    state.params.fileName = params.fileName;
    state.params.pageId = params.pageId;
    state.params.itemIds = params.itemIds;
    state.params.itemType = params.itemType;
    state.params.multiSelect = params.multiSelect; */
    state.params = params;
  },

  /* context menu 초기화 */
  resetStateParams(state) {
    state.params.pageId = "";
    state.params.itemIds = "";
    state.params.itemType = "";
    state.params.multiSelect = false;
  }
};
export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};



// WEBPACK FOOTER //
// ./src/js/store/modules/contextMenu.js